import { combineReducers } from 'redux';
import paymentReducer from '../paymentHandler';


const PaymentReducer = combineReducers({
  payment: paymentReducer,

});

export default PaymentReducer;
